import { FC, useEffect, useState } from 'react';
import {
  AccountPAStatsDialog,
  PayoutRequestDialog,
  PayoutRequestInformation,
  PayoutRequestTable,
} from '@features/admin/payoutRequests';
import {
  BalanceStackedData,
  DialogStatus,
  PaAccounts,
  PayoutRes,
  StackedData,
  TPayout,
} from '@src/types';
import {
  addNotes,
  getDailyProfitLossAndBalance,
  getDailyTradeVolumesAndContracts,
  getPayouts,
  getPayoutStatus,
} from '@src/services/payout.ts';
import { AddNotePopup } from '@features/admin/users/AddNotePopup.tsx';

export const ActivePayoutRequests: FC = () => {
  const [open, setOpen] = useState(false);
  const [openNote, setOpenNote] = useState(false);
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [item, setItem] = useState<TPayout | undefined>(undefined);
  const [status, setStatus] = useState(DialogStatus.Request);
  const [payouts, setPayouts] = useState<PayoutRes | null>(null);
  const [payoutSelected, setPayoutSelected] = useState<TPayout | null>(null);
  const [dailyTradeVolumesAndContracts, setDailyTradeVolumesAndContracts] =
    useState<StackedData[]>([]);
  const [dailyProfitLossAndBalance, setDailyProfitLossAndBalance] = useState<
    BalanceStackedData[]
  >([]);
  const [paAccounts, setPaAccounts] = useState<PaAccounts | null>(null);

  const fetchPayouts = async () => {
    const res = await getPayouts();

    setPayouts(res.data);
  };

  useEffect(() => {
    fetchPayouts().then();
  }, []);

  const fetchPayoutStatus = async (account_id: number) => {
    const res = await getPayoutStatus(account_id);

    setPaAccounts(res.data);
  };

  const handleApprove = (item: TPayout) => {
    setItem(item);
    setOpenActionDialog(true);
    setStatus(DialogStatus.Approve);
  };
  const handlePay = (item: TPayout) => {
    setItem(item);
    setOpenActionDialog(true);
    setStatus(DialogStatus.Request);
  };

  const handleChart = async (payout: TPayout) => {
    setOpen(true);
    setPayoutSelected(payout);
    await fetchPayoutStatus(payout.leeloo_account_id);
    const res1 = await getDailyTradeVolumesAndContracts(
      payout.leeloo_account_id
    );
    const res2 = await getDailyProfitLossAndBalance(payout.leeloo_account_id);

    setDailyTradeVolumesAndContracts(res1.data);
    setDailyProfitLossAndBalance(res2.data);
  };

  const handleConfirmNote = async (val: string) => {
    if (!payoutSelected?.id) return;
    await addNotes(payoutSelected.id, val);
    await fetchPayouts();
  };

  return (
    <div>
      <PayoutRequestInformation className={'mb-5'} data={payouts} />
      <PayoutRequestTable
        data={payouts?.payouts ?? []}
        onApprove={handleApprove}
        onChart={handleChart}
        onNote={(item) => {
          setPayoutSelected(item);
          setOpenNote(true);
        }}
        onPay={handlePay}
      />
      <AccountPAStatsDialog
        dailyProfitLossAndBalance={dailyProfitLossAndBalance}
        dailyTradeVolumesAndContracts={dailyTradeVolumesAndContracts}
        open={open}
        paAccounts={paAccounts}
        payoutSelected={payoutSelected}
        onOpenChange={setOpen}
      />
      <PayoutRequestDialog
        item={item}
        open={openActionDialog}
        refreshData={fetchPayouts}
        status={status}
        onOpenChange={setOpenActionDialog}
      />
      <AddNotePopup
        noteEdit={payoutSelected?.note}
        open={openNote}
        title={`Payout Note: ${payoutSelected?.leeloo_account.rithmic_account_name ?? ''}`}
        onConfirm={handleConfirmNote}
        onOpenChange={(val) => {
          setPayoutSelected(null);
          setOpenNote(val);
        }}
      />
    </div>
  );
};
